export var THANK_YOU = 'Thank you!';
export var RETURN_TO_PROJECT = 'Return to your project';
export var TEST_IDS = {
  RETURN_TO_PROJECT_BUTTON: 'return-to-project-button',
  SUCCESS_CONTENT_WRAPPER: 'success-content-wrapper'
};
export var COMPONENT_IDS = {
  PAYMENT_SUCCESS_TITLE: 'payment-success-title',
  PAYMENT_SUCCESS_DESCRIPTION: 'payment-success-description'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/SuccessContent/constants.js
// module id = 1543
// module chunks = 11